import { render } from "./PlansWrapper.vue?vue&type=template&id=ddae2d42&scoped=true&ts=true"
import script from "./PlansWrapper.vue?vue&type=script&lang=ts"
export * from "./PlansWrapper.vue?vue&type=script&lang=ts"

import "./PlansWrapper.vue?vue&type=style&index=0&id=ddae2d42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddae2d42"]])

export default __exports__